import React from 'react';
import styled from 'astroturf/react';
import _Container from "Base-Container.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/News/Base.tsx?styleId=Container";


const Container = /*#__PURE__*/styled("div", null, {
  displayName: "Container",
  styles: _Container
});

interface Props {
  className?: string;
  hoisted?: boolean;
  variant?: 'default' | 'dense';
}

const Base: React.FC<React.PropsWithChildren<Props>> = ({
  className,
  children,
  hoisted,
  variant = 'default',
}) => {
  return (
    <Container className={className} hoisted={hoisted} variant={variant}>
      {children}
    </Container>
  );
};

export default Base;
